import "./insChartSelector.scss";
import { AuxSelect } from "@blk/aladdin-react-components-es";
import { AuxButtonSizeEnum } from "@blk/aladdin-web-components";
import React from "react";
import { useDispatch } from "react-redux";
import { getTextWidth } from "common/html-width-helpers";
import { getActualName } from "components/widgets/base/widget-title/helper";
import { useCurrentWidget, usePatchedWidgetComponentProps, useSelectedValues, useWidgetChildrenId, useWidgetCurrentEndDate, useWidgetCurrentGranularity, useWidgetCurrentStartDate } from "components/widgets/hooks/use-current-widget";
import { useGetSelectedReferenceDate } from "components/workspaces/hooks/use-current-dashboard";
import { appInsightEvents } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { setCurrentStatusSelected } from "store/current-dashboard";
import { ChartSelectSlotProps } from "store/current-dashboard/types";
import { getCurrentLocalTime } from "common/date-utils";
const allowSelect = (value, current, all, selected) => {
    if (!current.childOf) {
        return true;
    }
    for (const child of current.childOf) {
        if (Number.isInteger(child)) {
            const parent = all?.find((a) => a.order === child);
            if (parent) {
                const forbiddenChildGroups = Object.entries(parent.selectValues).find(([key]) => key === selected?.[parent.order])?.[1]?.forbiddenChildGroups || [];
                if (forbiddenChildGroups.includes(value.groupName || "")) {
                    return false;
                }
            }
        }
    }
    return true;
};
const selectIconSize = 26;
const selectTextMarginSize = 16;
const selectLabelMarginSize = 12;
export const InsChartSelector = ({ sectionId, widgetId, slot }) => {
    const asOfDate = useGetSelectedReferenceDate(), childrenId = useWidgetChildrenId(sectionId, widgetId), componentProps = usePatchedWidgetComponentProps(sectionId, widgetId), currentGranularity = useWidgetCurrentGranularity(sectionId, widgetId), currentWidget = useCurrentWidget(sectionId, widgetId), dispatch = useDispatch(), endDate = useWidgetCurrentEndDate(sectionId, widgetId), selectProps = componentProps.dataSelectProps?.filter((prop) => (prop.slot ?? ChartSelectSlotProps.left) === slot), selectedValues = useSelectedValues(sectionId, widgetId), selectedValuesArray = Object.values(selectedValues), startDate = useWidgetCurrentStartDate(sectionId, widgetId);
    const actualName = getActualName({ asOfDate, currentGranularity, endDate, selectedValues, startDate, widgetName: currentWidget?.name, widgetProps: componentProps });
    const handleSelectionChange = (event, index) => {
        appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.ChangeWidgetView, properties: { LocalTimestamp: getCurrentLocalTime() } }, { widgetName: actualName });
        dispatch(setCurrentStatusSelected({
            childrenId,
            dataSelectProps: componentProps.dataSelectProps,
            forbiddenChildGroups: event.detail.value.value?.forbiddenChildGroups,
            order: index,
            sectionId,
            selectedValue: event.detail.value.value?.value,
            widgetId
        }));
    };
    return React.createElement("div", { className: "chartSelectors" }, selectProps?.map((select) => {
        const labelSize = select.label ? "" : ` - ${selectTextMarginSize}px`;
        const maxWidth = `calc(100% / ${selectProps.length}${labelSize} - 0.5px)`;
        const minTextWidth = Math.max(...Object.values(select.selectValues).map((val) => getTextWidth(`${val.displayName.substring(0, 3)}...`)));
        const maxLabelWidth = select.label ? getTextWidth(select.label) + selectLabelMarginSize : 0;
        const minWidth = minTextWidth + maxLabelWidth + selectTextMarginSize + selectIconSize;
        const data = Object.values(Object.entries(select.selectValues).reduce((acc, [key, val]) => {
            const shouldDisableSelectItem = selectedValuesArray.some((v, index) => index !== select.order && v === key);
            if (allowSelect(val, select, selectProps, selectedValues)) {
                const groupName = val.hideGroupName ? "" : val.groupName;
                acc[groupName || ""] = {
                    label: groupName,
                    values: [
                        ...acc[groupName || ""]?.values || [],
                        {
                            displayValue: val.displayName,
                            isDisabled: shouldDisableSelectItem,
                            isSelected: key === selectedValues?.[select.order],
                            value: { forbiddenChildGroups: val.forbiddenChildGroups, value: key }
                        }
                    ]
                };
            }
            return acc;
        }, {}));
        return React.createElement("div", { style: {
                maxWidth,
                minWidth: `${minWidth}px`
            }, key: `${sectionId}-${widgetId}-${select.order}` },
            React.createElement(AuxSelect, { label: select.label, data: data, isLeftLabel: true, size: AuxButtonSizeEnum.SMALL, onSelectionChanged: (event) => handleSelectionChange(event, select.order), hasInitialOptionPlaceholder: false }));
    }));
};
